import React, {Component} from 'react';
import Style from "./FJRetry.module.less";

class FJRetry extends Component {
  render() {
    let {retryCallback, desc, retryText} = this.props;
    return (
      <div className={Style.retry}>
        <span className={Style.retry_desc}>{desc}</span>
        <div onClick={retryCallback} className={Style.retry_btn}>{retryText}</div>
      </div>
    )
  }
}

export default FJRetry;